export default __webpack_public_path__ + "static/media/Megaman.dcc2d8a9.png";